import mitt from 'mitt';

export const CURRENT_COUNTRY_CHANGED = 'currentCountryChanged';
export const CURRENT_USER_IS_LOGGED = 'currentUserIsLogged';

export const PRODUCT_ADDED_TO_CART = 'tracking:productAddedToCart';
export const PRODUCT_FAVOURITED = 'tracking:productFavourited';
export const PRODUCT_UNFAVOURITED = 'tracking:productUnfavourited';
export const PRODUCT_VIEWED = 'tracking:productViewed';
export const MODEL_VIEWED = 'tracking:modelViewed';

export const emitter = mitt();
